<template>
  <ams-table
    :heading="heading"
    :ams_api_path="ams_api_path"
    :ams_type="ams_type"
    :ams_fields="ams_fields"
    :describe_belongs_to="describe_belongs_to"
    :filtering="filtering"
    :refresh="refresh"
    :refreshed="doRefresh"
    :reroute_name="reroute_name"
    :ams_template="ams_template"
  />
</template>

<script>
import AmsTable from './AmsTable.vue'

export default {
  components: {
    AmsTable
  },
  props: {
    filtering: {
      Type: Object
    },
    refresh: {
      Type: Boolean
    },
    ams_template: {
      Type: Object
    }
  },
  data() {
    return {
      heading: 'Product Models',
      ams_type: 'product-models',
      ams_api_path: 'api/admin/v1',
      reroute_name: 'ProductModelCreateScreen',
      ams_fields: [
       { 
          key: 'attributes.name',
          label: 'Model Name',
          sortable: true,
          filterable: true,
          class: 'text-left',
          sortDirection: 'asc' 
        },
       { 
          key: 'attributes.description',
          label: 'Description',
          sortable: true,
          filterable: true,
          class: 'text-left',
          sortDirection: 'asc' 
        },
      ],
      describe_belongs_to: [
        {
          prepend: '',
          type: 'brands',
          description_attr: 'name',
          append: ''
        },
        {
          prepend: ' ',
          type: 'interests',
          description_attr: 'name',
          append: ''
        },
      ]
    }
  },
  methods: {
    doRefresh() {
      this.emit('refreshed', true)
    }
  }
}
</script>